import { render, staticRenderFns } from "./TvScore.vue?vue&type=template&id=0a8a276a&scoped=true&"
import script from "./TvScore.vue?vue&type=script&lang=js&"
export * from "./TvScore.vue?vue&type=script&lang=js&"
import style0 from "./TvScore.vue?vue&type=style&index=0&id=0a8a276a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8a276a",
  null
  
)

export default component.exports